module.exports = __webpack_public_path__ + "media/10.f4d013b5.wav";